<template>
    <a-modal v-model="visible" title="删除账号" on-ok="handleSubmit">
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click=" handleSubmit">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>

        <a-row class="item">
          <a-col :span="5"><label >账号名：</label></a-col>
          <a-col :span="17"><span>{{text.alias}}</span></a-col>
        </a-row>
        <a-row class="item">
          <a-col :span="5"><label >手机号：</label></a-col>
          <a-col :span="17"><span>{{text.account}}</span></a-col>
        </a-row>
    </a-modal>
</template>
<script>
export default {
  props:{
    mode:{
      type:String,
      default:'1'
    },
    pageNum:{
      type:Number,
      default:1
    },
    rowSize:{
      type:Number,
      default:0
    },
  },
  data() {
    return {
      formItemLayout:'',
      loading: false,
      visible: false,
      formLayout: 'horizontal',
      text:{},
      form: this.$form.createForm(this, { name: 'coordinated' }),
      page:1
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {...values}
          params.id = this.text.id;
          let url = '';
          if (this.mode=='1') {
            url = '/manager/deleteRecord'
          } else if(this.mode=='2'){
             url = '/supplier/deleteRecord'
          }else if(this.mode=='3'){
             url = '/distributor/deleteRecord'
          }
          this.$http.post(url,'',{params}).then(res=>{
            if (res.result) {
              this.$message.success('删除成功')
              if(this.rowSize == 1){
                  this.page = this.pageNum == 1 ? 1 : this.pageNum - 1;
              }
              this.handleCancel();
              this.$emit("getdata",this.page);
            }else{
              this.$message.warning(res.message)
            }
          })
        }
      });
    },
    showModal(text) {
      this.text = text;
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
      this.form.resetFields();
    },
  },
};
</script>
